// gestionInventarioCuadreSchema.tsx

import * as yup from 'yup';

export const gestionInventarioCuadreSchema = yup.object({

});
